// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CategoryDescription{max-width:1120px;margin-top:30px;line-height:var(--leading-loose)}.CategoryDescription_Center{margin-left:auto;margin-right:auto}@media (min-width: 768px){.CategoryDescription{margin-top:95px}}.CategoryDescription p{margin-bottom:25px}.CategoryDescription p:last-child{margin-bottom:0}\n", ""]);
// Exports
module.exports = exports;
